import { routes } from "./routes";

export const getRoute = (id: string) => {
  return routes.find((item) => {
    return item.id === id;
  });
};
